if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              
              
            }

            

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              document.querySelector('.custom-cart-count')?.classList.remove('pulse');
              void document.querySelector('.custom-cart-count')?.offsetWidth;
              document.querySelector('.custom-cart-count')?.classList.add('pulse');
              const productImage = document.querySelector('.product__media img');
const cartIcon = document.querySelector('#cart-icon-bubble');

if (productImage && cartIcon) {

  const flyingImage = productImage.cloneNode(true);

  const start = productImage.getBoundingClientRect();
  const end = cartIcon.getBoundingClientRect();

  flyingImage.style.position = 'fixed';
  flyingImage.style.left = start.left + 'px';
  flyingImage.style.top = start.top + 'px';
  flyingImage.style.width = start.width + 'px';
  flyingImage.style.height = start.height + 'px';
  flyingImage.style.zIndex = '9999';
  flyingImage.style.pointerEvents = 'none';
  flyingImage.style.transition =
    'all 0.8s cubic-bezier(.2,.8,.2,1)';

  document.body.appendChild(flyingImage);

  requestAnimationFrame(() => {
    flyingImage.style.left = end.left + 'px';
    flyingImage.style.top = end.top + 'px';
    flyingImage.style.width = '30px';
    flyingImage.style.height = '30px';
    flyingImage.style.opacity = '0';
  });

  setTimeout(() => {
    flyingImage.remove();
  }, 850);

  setTimeout(() => {
  flyingImage.remove();
}, 800);

const popup = document.getElementById('fitomat-mini-cart');
const popupImage = document.getElementById('fitomat-mini-cart-image');
const popupTitle = document.getElementById('fitomat-mini-cart-title');

if (popup && popupImage && popupTitle) {

  popupImage.src = productImage.src;

  const titleElement = document.querySelector('.product__title h1');
  if (titleElement) {
    popupTitle.textContent = titleElement.textContent.trim();
  }

  setTimeout(() => {
  fetch('/cart.js?time=' + Date.now())
  .then(response => response.json())
  .then(cart => {
 

    let total = cart.total_price / 100;

    let freeShipping = 55;
let progress = Math.min((total / freeShipping) * 100, 100);
let nextText = '';

if (total >= freeShipping) {
  nextText = '🎉 Kostenloser Versand freigeschaltet!';
} else {
  nextText = `📦 Nur noch ${(freeShipping - total).toFixed(2).replace('.', ',')} € bis zum kostenlosen Versand`;
}

const progressFill = document.getElementById('popup-progress-fill');
const progressText = document.getElementById('popup-shipping-text');

if (progressFill) {
  progressFill.style.width = `${progress}%`;
  progressFill.style.background = "#8f5cff";
progressFill.style.height = "5px";
progressFill.style.display = "block";
  console.log("Progress:", progress);
console.log("Width:", progressFill.style.width);
console.log(progressFill);
}

if (progressText) {
  progressText.innerHTML = nextText;
}

  });
  }, 200);

  popup.classList.add('active');

  const popupDuration = window.innerWidth <= 768 ? 11000 : 11000;

setTimeout(() => {
  popup.classList.remove('active');
}, popupDuration);
}
}
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });

fetch('/cart.js')
  .then((response) => response.json())
  .then((cart) => {

    // Hauptshop
const defaultBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');

if (defaultBubble) {
  defaultBubble.textContent = cart.item_count;

  defaultBubble.classList.remove('pulse');
  void defaultBubble.offsetWidth;
  defaultBubble.classList.add('pulse');
}

// Fitomat-Shop
const customBubble = document.querySelector('.custom-cart-count');

if (customBubble) {
  customBubble.textContent = cart.item_count;

  customBubble.classList.remove('pulse');
  void customBubble.offsetWidth;
  customBubble.classList.add('pulse');
}

  });
              
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      // this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                // this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
